import React from 'react';
import PrimecutStudio from './components/PrimecutStudio';
import './index.css';

function App() {
    return <PrimecutStudio />;
}

export default App;
